export class Template {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {
    return {
      title: this.fields.attributes.title,
      componentList: this.fields.attributes.relationships.map((rel) => {
        return {
          component: rel.component,
          source: rel.source,
          location: rel.location
        };
      })
    };
  }
}
